import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { apiFetch } from '../api'

export default function Signup() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [ok, setOk] = useState('')
  const [form, setForm] = useState({
    tenant_name: '',
    tenant_slug: '',
    username: '',
    email: '',
    full_name: '',
    password: '',
  })

  function onChange(key, value) {
    setForm((s) => ({ ...s, [key]: value }))
  }

  async function onSubmit(e) {
    e.preventDefault()
    setError('')
    setOk('')
    setLoading(true)
    try {
      const payload = {
        tenant_name: form.tenant_name.trim(),
        tenant_slug: form.tenant_slug.trim() || undefined,
        username: form.username.trim(),
        email: form.email.trim(),
        full_name: form.full_name.trim() || undefined,
        password: form.password,
      }
      await apiFetch('/api/auth/signup', { method: 'POST', body: payload })
      setOk('Compte créé. Vérifie ton email puis connecte-toi.')
      setTimeout(() => navigate('/auth', { replace: true }), 1500)
    } catch (err) {
      setError(err?.message || 'Erreur création de compte')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="mx-auto max-w-xl rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-semibold text-slate-900">Créer votre compte</h1>
        <p className="mt-1 text-sm text-slate-500">Onboarding self-service Fedis</p>

        {error ? <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div> : null}
        {ok ? <div className="mt-4 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-700">{ok}</div> : null}

        <form className="mt-5 grid gap-3" onSubmit={onSubmit}>
          <input className="rounded-lg border border-slate-300 px-3 py-2 text-sm" placeholder="Nom de l'entreprise" value={form.tenant_name} onChange={(e) => onChange('tenant_name', e.target.value)} required />
          <input className="rounded-lg border border-slate-300 px-3 py-2 text-sm" placeholder="Slug (optionnel)" value={form.tenant_slug} onChange={(e) => onChange('tenant_slug', e.target.value)} />
          <input className="rounded-lg border border-slate-300 px-3 py-2 text-sm" placeholder="Nom utilisateur owner" value={form.username} onChange={(e) => onChange('username', e.target.value)} required />
          <input className="rounded-lg border border-slate-300 px-3 py-2 text-sm" placeholder="Email owner" type="email" value={form.email} onChange={(e) => onChange('email', e.target.value)} required />
          <input className="rounded-lg border border-slate-300 px-3 py-2 text-sm" placeholder="Nom complet (optionnel)" value={form.full_name} onChange={(e) => onChange('full_name', e.target.value)} />
          <input className="rounded-lg border border-slate-300 px-3 py-2 text-sm" placeholder="Mot de passe fort" type="password" value={form.password} onChange={(e) => onChange('password', e.target.value)} required />

          <button
            type="submit"
            disabled={loading}
            className="mt-2 rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 disabled:opacity-60"
          >
            {loading ? 'Création...' : 'Créer mon compte'}
          </button>
        </form>

        <div className="mt-4 text-sm text-slate-600">
          Déjà inscrit ? <Link className="font-medium text-slate-900 underline" to="/auth">Se connecter</Link>
        </div>
      </div>
    </div>
  )
}

